import { Toaster } from '@/components/ui/toaster';
import { Toaster as Sonner } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { ContextsProvider } from '@/context';
import AppRoutes from '@/AppRoutes';
import { VERSION } from '@/lib/utils';

Sentry.init({
  dsn: 'https://d66d2b85ce68f41b5a7aa6c494800809@o4510274504228864.ingest.us.sentry.io/4510274549186565',
  sendDefaultPii: true,
  release: VERSION,
  beforeSend(event) {
    const values = event.exception?.values || [];

    const ignoreMessages = ['Acesso negado', 'expired token'];

    if (
      values.some((v) =>
        ignoreMessages.some((msg) =>
          String(v.value || '')
            .toLowerCase()
            .includes(msg.toLowerCase()),
        ),
      )
    ) {
      return null;
    }

    if (
      (event.request?.headers && event.request.headers['x-http-status-code'] === '401') ||
      event.request?.headers?.['x-http-status-code'] === '403'
    ) {
      return null;
    }
    return event;
  },
});

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <BrowserRouter>
        <ContextsProvider>
          <Toaster />
          <Sonner />
          <AppRoutes />
        </ContextsProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
